module.exports = __webpack_public_path__ + "static/media/galerija_2014 (43).3987545d.jpg";